<template>
  <b-row>
    <b-col lg="6">
      <h3>{{ $t("edu_courses.edu_courses") }}</h3>
    </b-col>
    <b-col lg="6">
      <b-form-group id="input-group-29 " :label="$t('edu_programs.semester')" label-for="input-29">
        <b-form-select v-model="num_of_semester" :options="semesters" text-field="name" value-field="id"
          @click="clickSemester" @input="changeSemester(num_of_semester)" />
      </b-form-group>
    </b-col>
    <b-col lg="12" style="height: 500px; overflow: auto">
      <hr />
      <b-list-group v-if="num_of_semester > 0">
        <b-list-group-item class="d-flex">
          <b-input type="text" v-model="qr" /></b-list-group-item>
        <b-list-group-item class="d-flex" v-for="course in qr.length > 0
        ? courses.filter((a) => a.code == qr)
        : courses" :key="course.id">
          <b-col lg="8 ">
            <div class="demo-inline-spacing">
              <b-form-checkbox v-model="courseId" @change="changeCourse()" :value="course.id" unchecked-value="0"
                class="custom-control-primary">
                {{ course.code }} -{{ course.name }}
              </b-form-checkbox>
            </div>
          </b-col>
          <!-- <b-col lg="4" v-if="haveCourseId(course.id)">
            <b-form-input
              v-model="data[num_of_semester].number[course.id]"
              type="number"
              :placeholder="$t('edu_programs.chapter_number')"
            />
          </b-col> -->
        </b-list-group-item>
      </b-list-group>
    </b-col>
    <hr />

    <b-col lg="6">
      <b-button block variant="primary" @click="submit()">
        <i class="fa fa-plus" /> {{ $t("site.save") }}
      </b-button>
    </b-col>
    <b-col lg="6">
      <b-button block @click="goToTable()" variant="success">
        <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import EduProgramsController from "@/Controllers/EduProgramsController";
import EduCoursesController from "@/Controllers/EduCoursesController";
import SemesterController from "@/Controllers/SemesterController";
export default {
  props: ["eduProgram"],

  data() {
    return {
      courses: [],
      coursesSelected: [],
      eduProgramId: this.$route.params.eduProgramId,
      res: false,
      semesters: [],
      num_of_semester: 0,
      data: [],
      programCourses: [],
      qr: "",
      courseId: []
    };
  },
  created() {
    this.getData();
  },

  methods: {
    haveCourseId(id) {
      return this.data[this.num_of_semester].courseId.includes(id);
    },
    async getData() {
      

      new EduCoursesController().GetAll().then((res) => {
        this.courses = res.filter((a) => a.flixable == 0);
      });
      if (this.eduProgramId) {
        const res = await  new EduProgramsController() 
          .getCourseByProgram(this.eduProgramId, true)
          this.programCourses = res.courses;
      }
      this.semesters = await new SemesterController().GetAll({
        filter: "edu_program_id|" + this.$route.params.eduProgramId,
      });
      this.semesters.forEach(num_of_semester => {
        let courseId = [];
        this.programCourses.forEach((element) => {
          console.log(element);
          if (element.pivot.semester == num_of_semester.id)
            courseId.push(element.id);
        });
        console.log(courseId);
        this.data[num_of_semester.id] = courseId;
      });

    },
    changeSemester() {
      if (!this.courses) return;
      console.log(this.num_of_semester);
      this.setAllData();
    },
    clickSemester() {
      console.log(this.num_of_semester);
    },
    async returnData() {
      return this.res;
    },
    async goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      // let data = [];
      // for (const key in this.data) {
      //   const element = this.data[key];
      //   element.forEach((el) => {
      //     // data[el] = { semester: key, ch: element.number[el] };
      //     data[el] = { semester: key, ch: 1 };
      //   });
      // }

      if (!this.eduProgramId) this.eduProgramId = this.eduProgram.id;
      this.res = await new EduProgramsController().SaveCourses(
        this.eduProgramId,
        {  data:this.data }
      );
    },
    changeCourse() {
      this.data[this.num_of_semester] = this.courseId;
    },
    setAllData() {
      // if (this.data[this.num_of_semester]) return;
      this.courseId = [];
      this.courseId = this.data[this.num_of_semester];

    },
  },
};
</script>

<style>

</style>